<template>
  <div class="app flex-row align-items-center bg-logisty-dark-main">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form v-on:submit.prevent>
                  <h1>เข้าสู่ระบบ</h1>
                  <div>
                    <label for="username">Username:</label>
                    <b-input-group class="mb-3">
                      <b-form-input
                        id="username"
                        type="text"
                        class="form-control"
                        v-model="username"
                      />
                    </b-input-group>
                    <label for="password">Password:</label>
                    <b-input-group class="mb-3">
                      <b-form-input
                        id="password"
                        type="password"
                        class="form-control"
                        v-model="password"
                      />
                    </b-input-group>
                  </div>
                  <b-row v-if="showButton">
                    <b-col cols="6">
                      <b-button
                        variant="primary"
                        class="px-4"
                        id="login-button"
                        key="login-button"
                        @click="passwordLogin"
                      >เข้าสู่ระบบ</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
    <ModalLoading />
  </div>
</template>

<script>
import ModalLoading from '../components/ModalLoading'
import User from '../services/http/User'
export default {
  name: 'home',
  components: {
    ModalLoading
  },
  data () {
    return {
      username: null,
      password: null
    }
  },
  computed: {
    showButton: function () {
      if (this.username && this.password) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    async passwordLogin () {
      Window.Event.$emit('showModalLoading')
      var user = new User()
      try {
        var login = await user.passwordLogin(this.username, this.password)
        if (login.code === 1) {
          this.$cookies.set('token', login.token)
          // go dashboard
          this.$router.push('dashboard')
        }
      } catch (error) {
        console.log(error)
      }

      Window.Event.$emit('closeModalLoading')
    }
  }
}
</script>
